import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '9.3502 6.2261'
  const rightTransformOrigin = '39.6104 6.2261'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0 6.40591L21.96 4.56591L19.92 1.92591C19.92 1.92591 13.49 1.29591 7.84 1.90591C2.19 2.51591 0 6.40591 0 6.40591Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M0 4.75602C0 4.75602 4.39 1.89602 8.15 1.89602C11.91 1.89602 20.7 2.92602 20.7 2.92602L18.66 0.286022C18.66 0.286022 13.48 -0.343979 7.84 0.266021C2.19 0.866021 0 4.75602 0 4.75602Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M53.9402 4.75602C53.9402 4.75602 49.5502 1.89602 45.7902 1.89602C42.0302 1.89602 33.2402 2.92602 33.2402 2.92602L35.2802 0.286022C35.2802 0.286022 40.4602 -0.343979 46.1002 0.266021C51.7502 0.866021 53.9402 4.75602 53.9402 4.75602Z"
          fill={fill}
        />
        <path
          d="M53.94 6.40591L31.98 4.56591L34.02 1.92591C34.02 1.92591 40.45 1.29591 46.1 1.90591C51.75 2.51591 53.94 6.40591 53.94 6.40591Z"
          fill={`url(#${randomGradientId2})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="10.9801"
            y1="7.23013"
            x2="10.9801"
            y2="2.89907"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="42.9601"
            y1="7.23013"
            x2="42.9601"
            y2="2.89907"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
